import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const categories = [
  {
    type: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '热播剧集 · 年代大戏 · 悬疑刑侦',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20living%20room%20with%20a%20glowing%20television%20screen%20at%20night%20deep%20blue%20tones%20with%20warm%20orange%20lamplight%20cozy%20modern%20interior%20high%20detail&width=800&height=500&seq=cat-series&orientation=landscape',
  },
  {
    type: '电影',
    icon: 'ri-film-line',
    desc: '院线大片 · 科幻动作 · 文艺剧情',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20vintage%20film%20projector%20casting%20warm%20orange%20light%20in%20a%20dark%20studio%20deep%20blue%20shadows%20nostalgic%20movie%20theater%20atmosphere%20high%20detail&width=800&height=500&seq=cat-movie&orientation=landscape',
  },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto px-4 py-12 md:px-10 md:py-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
        {categories.map((cat) => {
          const count = movies.filter((m) => m.type === cat.type).length;
          return (
            <Link
              key={cat.type}
              to={`/category?type=${encodeURIComponent(cat.type)}`}
              className="group relative flex min-h-[180px] cursor-pointer items-end overflow-hidden rounded-lg ring-1 ring-background-200/70 transition-all duration-300 hover:ring-primary-300 md:min-h-[220px]"
            >
              <img
                src={cat.image}
                alt={`${cat.type}分类`}
                title={`${cat.type} 伊人在线`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/40 to-transparent"></div>
              <div className="relative z-10 flex w-full items-center justify-between p-5 md:p-7">
                <div>
                  <div className="flex items-center gap-2 text-accent-400">
                    <i className={`${cat.icon} text-2xl`}></i>
                    <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                      {cat.type}
                    </h3>
                  </div>
                  <p className="mt-2 text-sm text-background-200">{cat.desc}</p>
                  <p className="mt-1 text-xs text-background-300">共 {count} 部作品</p>
                </div>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur-sm transition-colors group-hover:bg-accent-500 group-hover:text-accent-950">
                  <i className="ri-arrow-right-line text-xl"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}